export const en = {
    'action-unsubscribe': 'Unsubscribe',
    description: 'Add the users you want to subscribe to page or cluster updates. Subscribers will recieve update notifications by email.',
    'empty-title': 'Page has no subscribers',
    'error-add-subscribers': 'Couldn\'t add subscribers',
    'error-add-subscribers-forbidden': 'Users who don\'t have access to the page can\'t be subscribed',
    'error-add-subscribers-subscribed': 'The user is already subscribed to this page or cluster',
    'error-del-subscribers': 'Couldn\'t unsubscribe users',
    'error-get-subscribers': 'Couldn\'t load the list of subscribers',
    placeholder: 'Employee name or username',
    'subscription-to-cluster': 'Cluster',
    'subscription-to-page': 'Page',
    title: 'Subscriptions'
};
